import { useContext, useEffect, useState } from "react";

import { Row } from 'react-bootstrap'

import DashboardContext from "../../../Context";
import FormAddres from "../../Order/Order/FormAddres";

export default function AddresCoustoumer({ id }) {

    const { sideBardata } = useContext(DashboardContext)

    const [arryactions, setArryactions] = useState([]);

    useEffect(() => {
        if (sideBardata) {
            sideBardata.map(item => {
                item.controllers.filter(find => {
                    if (`/${find.controller}` === '/Address') {
                        setArryactions(find.actions)
                        return find
                    }
                })
            })
        }
        return () => {

        };
    }, []);

    return (
        <>
            <FormAddres urlWebsilte='/address' id={id} isprofile />
        </>
    )
}
